import Component from '@glimmer/component';
import PhoneInput, {
  type MetaData
} from 'ember-phone-input/components/phone-input';

interface Signature {
  Element: HTMLDivElement;
  Args: {
    phone: string | null;
    setPhone: (value: string | null, metadata: MetaData) => void;
    separateDialCode: boolean;
    preferredCountries: string[];
    name: string;
    disabled?: boolean;
    placeholder?: string;
  };
}

export default class PhoneComponent extends Component<Signature> {
  setPhone = (value: string | null, metadata: MetaData) => {
    this.args.setPhone(value, metadata);
  };

  <template>
    {{! CSS trick to make sure PhoneInput takes the full width of the parent }}
    <div class='flex flex-col'>
      <PhoneInput
        @preferredCountries={{@preferredCountries}}
        @number={{@phone}}
        @update={{@setPhone}}
        @separateDialCode={{@separateDialCode}}
        @disabled={{@disabled}}
        @customPlaceholder={{@placeholder}}
        @autocomplete='tel'
        name={{@name}}
        ...attributes
      />
    </div>
  </template>
}
